/// <amd-module name="TFS/Samples/MasterDetails/SampleData" />
import { ArrayItemProvider, IItemProvider } from "VSSUI/Utilities/Provider";

export interface IPullRequest {
    author: string;
    commits: ICommit[];
    dateTime: string;
    hashCode: string;
    title: string;
}

export interface ICommit {
    author: string;
    dateTime: string;
    description: string;
    fileModifications: IFileModification[];
    hashCode: string;
}

export interface IFileModification {
    type: "add" | "delete" | "replace";
    fileName: string;
    lineNumber: number;
    oldContent?: string;
    newContent?: string;
}

let dummyCommitCount = 0;
function createDummyCommit(): ICommit {
    dummyCommitCount += 1;
    return {
        author: "Temp Author",
        dateTime: "2019-10-02 10:00:00",
        description: `Temp commit ${dummyCommitCount}`,
        fileModifications: [
            {
                type: "delete",
                fileName: "something-else.json",
                lineNumber: 201,
                oldContent: "test-line"
            },
            {
                type: "replace",
                fileName: "some-file.tsx",
                lineNumber: 256,
                oldContent: "yes",
                newContent: "no"
            }
        ],
        hashCode: "temp-commit-" + dummyCommitCount
    };
}

const commitOne: ICommit = {
    author: "Person 1",
    dateTime: "2019-10-02 10:00:00",
    description: "Add accessibility support to Buttons",
    hashCode: "abc123",
    fileModifications: [
        {
            type: "add",
            fileName: "something.json",
            lineNumber: 102,
            newContent: "test-line"
        }
    ]
};

const commitTwo: ICommit = {
    author: "Person 2",
    dateTime: "2019-10-06 10:00:00",
    description: "Add accessibility support to Cards",
    hashCode: "def123",
    fileModifications: [
        {
            type: "delete",
            fileName: "something-else.json",
            lineNumber: 201,
            oldContent: "test-line"
        },
        {
            type: "replace",
            fileName: "some-file.tsx",
            lineNumber: 256,
            oldContent: "yes",
            newContent: "no"
        }
    ]
};

export const SampleData: IPullRequest[] = [
    {
        author: "Person 1",
        dateTime: "2019-10-02 10:00:00",
        hashCode: "abc123",
        title: "Add accessibility support to Buttons",
        commits: [commitOne]
    },
    {
        author: "Person 2",
        dateTime: "2019-10-02 10:00:00",
        hashCode: "abcdefg123456",
        title: "Add accessibility support to Cards",
        commits: [
            commitTwo,
            commitOne,
            ...Array(25)
                .fill(1)
                .map(createDummyCommit)
        ]
    }
];

export const pullRequestItemProvider: IItemProvider<IPullRequest> = new ArrayItemProvider<IPullRequest>(SampleData);
